import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/situacao_atendimentos${queryUrl}`)
  },
  insertNewSituacaoAtendimento(data) {
    return axios.post('/atendimento/situacao_atendimentos', data)
  },
  editSituacaoAtendimento(data) {
    return axios.put(`/atendimento/situacao_atendimentos/${data.id}`, data)
  },
  deleteSituacaoAtendimento(id) {
    return axios.delete(`/atendimento/situacao_atendimentos/${id}`)
  },
}
